// One CSV cell, safe for Excel. A cell starting with = + - @ (or tab / CR) is run as a formula
// by Excel - e.g. a customer name "=HYPERLINK(...)" - so it gets a leading single quote and
// shows as text. Real numbers (a -125.50 credit) stay numbers. Quotes, commas and line breaks
// are escaped the CSV way. Used by every client-side CSV export (Gap 23, 2026-10-31).
export function csvCell(v) {
  let s = v == null ? "" : String(v);
  const isNumber = typeof v === "number" || /^-?\d+(\.\d+)?$/.test(s);
  if (!isNumber && /^[=+\-@\t\r]/.test(s)) s = `'${s}`;
  return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}
